import { useContext } from 'react'
import { OverviewWidgetContext, FindMemberContext, ToggleContext } from '@typesApp/WidgetContextHolder'
import { WidgetContext } from './context'

export const useToggleWidgetContext = (): ToggleContext => {
  const context = useContext(WidgetContext)
  return context.toggle ?? {}
}

export const useOverviewWidgetContext = (): OverviewWidgetContext => {
  const context = useContext(WidgetContext)
  return context.overviewWidget ?? {}
}

export const useFindMemberContext = (): FindMemberContext => {
  const context = useContext(WidgetContext)
  return context.findMember ?? {}
}
